/**
 * Mouse buttons.
 */
export enum Button
{
    LEFT,
    MIDDLE,
    RIGHT,
    FOURTH,
    FIFTH
}
